module.exports = __webpack_public_path__ + "img/home_banner_web_BG2.73a1b3cc.png";